webpackJsonp([95314831745349],{

/***/ 1390:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ConditionalInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"operator","type":{"kind":"ENUM","name":"ConditionalOperator","ofType":null}},{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"quantity","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-conditional-input-819eb147a9ca068077a5.js